module.exports = __webpack_public_path__ + "img/getAddress.6659f153.svg";